import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        paragraph: {
            marginLeft: '18px',
        },
        textContainer: {
            display: 'flex',
            flexDirection: 'column',
        },
        container: {
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(1.5),
        },
        listIndicator: {
            width: '4px',
            height: '4px',
            margin: '10px 5px',
            borderRadius: '50%',
            backgroundColor: theme.palette.common.black,
            flexShrink: 0,
        },
        headerContainer: {
            display: 'flex',
            alignItems: 'center',
            gap: theme.spacing(0.5),
        },
    }
})

export default useStyles
